export function buildExternalAnnotatingRecordingList(recordings) {
  const defaultResult = { available: [], review: [], completed: [] };

  if (!Array.isArray(recordings)) throw new Error('Recordings must be an array');

  if (!recordings.length) return defaultResult;

  const result = recordings.reduce((acc, rec) => {
    const { externalAnnotationMetadata, flags = [] } = rec;

    const hasForExternalAnnotating = flags.includes('FOR_EXTERNAL_ANNOTATING');
    const hasExternallyAnnotated = flags.includes('EXTERNALLY_ANNOTATED');

    // Check if annotation was restarted (startedAt is more recent than completedAt)
    const startedAt = externalAnnotationMetadata?.startedAt;
    const completedAt = externalAnnotationMetadata?.completedAt;
    const wasRestarted = startedAt && completedAt && startedAt > completedAt;

    // Available for re-annotation: has FOR_EXTERNAL_ANNOTATING, not EXTERNALLY_ANNOTATED,
    // was previously completed, and hasn't been restarted yet
    const isAvailableForReannotation = hasForExternalAnnotating && !hasExternallyAnnotated && completedAt && !wasRestarted;

    if (!startedAt || isAvailableForReannotation) {
      acc.available.push(rec);

      return acc;
    }

    if (completedAt && !wasRestarted) {
      acc.completed.push(rec);

      return acc;
    }

    acc.review.push(rec);

    return acc;
  }, defaultResult);

  // sort by recordingStartedAt
  result.available.sort((a, b) => a.recordingStartedAt - b.recordingStartedAt);
  result.review.sort((a, b) => a.recordingStartedAt - b.recordingStartedAt);
  result.completed.sort((a, b) => a.recordingStartedAt - b.recordingStartedAt);

  return result;
}
